import { useTranslation } from 'react-i18next';

export default function AttorneyProfile() {
  const { t } = useTranslation('common');

  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-8">
        <div className="text-center mb-16">
          <p className="text-sm font-bold text-gray-500 tracking-wider uppercase mb-3">
            {t('about.badge')}
          </p>
          <h2 className="text-5xl font-serif text-gray-900 mb-6">
            {t('about.title')} <span className="italic">{t('about.titleItalic')}</span>
          </h2>
        </div>

        <div className="grid grid-cols-2 gap-12 mb-16">
          <div className="space-y-6">
            <p className="text-base text-gray-700 leading-relaxed">
              {t('about.description')}
            </p>
            <p className="text-base text-gray-700 leading-relaxed">
              {t('about.approach')}
            </p>
          </div>

          <div className="bg-gradient-to-br from-gray-900 to-gray-800 rounded-3xl p-10 text-white">
            <h3 className="text-2xl font-bold mb-4 text-white">
              {t('about.positioning.title')}
            </h3>
            <p className="text-sm text-gray-300 leading-relaxed">
              {t('about.positioning.description')}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
